{
  "body.hello": "Hallo,",
  "body.hello_name": "Hallo {name},",
  "body.footer": "Dit bericht komt van Cargofollow. Antwoorden op dit bericht worden niet gelezen.",
  "subject.sign_request": "Handtekening gevraagd voor zending {reference}",
  "body.sign_request.intro": "{organization} vraagt je om de vrachtbrief van zending {reference} te ondertekenen als {role}.",
  "body.sign_request.action": "Open deze link om te tekenen: {url}",
  "body.sign_request.expires": "De link blijft geldig tot {expires} en werkt één keer.",
  "body.sign_request.ignore": "Ken je dit verzoek niet? Dan kun je dit bericht negeren.",
  "sms.sign_request": "{organization}: teken de vrachtbrief van zending {reference}: {url}",
  "subject.otp": "Je verificatiecode voor Cargofollow",
  "body.otp.intro": "Je verificatiecode is {code}.",
  "body.otp.expires": "De code blijft {minutes} minuten geldig en werkt één keer.",
  "body.otp.ignore": "Heb je zelf geen code aangevraagd? Deel hem dan met niemand en negeer dit bericht.",
  "sms.otp": "{code} is je Cargofollow-verificatiecode. Geldig gedurende {minutes} minuten; deel hem met niemand.",
  "subject.pod_delivered": "Afleverbewijs beschikbaar voor zending {reference}",
  "body.pod_delivered.intro": "Zending {reference} is op {delivered_at} afgeleverd en ondertekend door {signer}.",
  "body.pod_delivered.remarks": "De ontvanger heeft de goederen onder voorbehoud aangenomen.",
  "body.pod_delivered.no_remarks": "De goederen zijn zonder voorbehoud aangenomen.",
  "body.pod_delivered.action": "Bekijk het afleverbewijs: {url}",
  "subject.authority_access": "Een autoriteit heeft zending {reference} opgevraagd",
  "body.authority_access.intro": "Op {accessed_at} heeft een bevoegde autoriteit de eFTI-gegevens van zending {reference} opgehaald via gate {gate}.",
  "body.authority_access.intro_no_gate": "Op {accessed_at} heeft een bevoegde autoriteit de eFTI-gegevens van zending {reference} opgehaald.",
  "body.authority_access.subsets": "Opgevraagde rechtsgronden: {subsets}. Alleen de gegevens die bij die gronden horen zijn verstrekt.",
  "body.authority_access.action": "Bekijk de zending en de volledige tijdlijn: {url}",
  "body.authority_access.webhook": "Je krijgt dit per e-mail omdat er geen webhook-endpoint naar efti.authority_access luistert. Stel er een in om deze melding direct in je eigen systeem te ontvangen.",
  "subject.invite": "Uitnodiging voor {organization} op Cargofollow",
  "body.invite.intro": "{inviter} nodigt je uit om als {role} mee te doen met {organization} in de Cargofollow-console.",
  "body.invite.action": "Open deze link om de uitnodiging te accepteren: {url}",
  "body.invite.expires": "De uitnodiging blijft 48 uur geldig.",
  "body.invite.ignore": "Ken je deze uitnodiging niet? Dan kun je deze mail negeren.",
  "subject.live_request": "Live-aanvraag van {organization}",
  "body.live_request.intro": "{requester} ({email}) vraagt live-toegang aan voor {organization}.",
  "body.live_request.organization": "Organisatie-id: {id}",
  "body.live_request.note": "Toelichting: {note}",
  "body.live_request.no_note": "Er is geen toelichting meegegeven.",
  "body.live_request.next": "Loop de conformiteitschecklist door en zet daarna live_enabled aan.",
  "role.owner": "eigenaar",
  "role.admin": "beheerder",
  "role.developer": "ontwikkelaar",
  "role.viewer": "meekijker",
  "role.consignor": "afzender",
  "role.carrier": "vervoerder",
  "role.consignee": "ontvanger",
  "sms.driver_otp": "{code} is je inlogcode voor Cargofollow. De code is {minutes} minuten geldig. Deel hem met niemand."
}
